// i18n/socialMedia.js

import { Instagram, Linkedin, Facebook } from "lucide-react";

export const socialMediaText = {
  en: {
    title1: "Come Join",
    title2: "My World",

    description:
      "Follow Maria Advisory across social platforms for business inspiration, leadership insights, practical growth strategies and community updates.",

    explore: "Explore Platform",
    visit: "Connect",

    cards: [
      {
        icon: Instagram,

        title: "Instagram",

        subtitle: "Behind the scenes",

        description: "Behind-the-scenes · workshop photos · daily insights",

        path: "https://www.instagram.com/mariaadvisory/",

        gradient: "from-pink-500 via-fuchsia-500 to-orange-400",
        border: "border-pink-300",
      },

      {
        icon: Facebook,

        title: "Maria Advisory",

        subtitle: "Business insights",

        description: "Events · workshops · business tips for SMEs",

        path: "https://www.facebook.com/mariaadvisory/",

        gradient: "from-blue-500 via-blue-600 to-indigo-700",
        border: "border-blue-300",
      },

      {
        icon: Facebook,

        title: "Maria Pooley",

        subtitle: "Personal journey",

        description: "Personal updates · Vietnam community · coaching insights",

        path: "https://www.facebook.com/maria.pooley286/",

        gradient: "from-sky-500 via-cyan-600 to-blue-800",
        border: "border-cyan-300",
      },

      {
        icon: Linkedin,

        title: "LinkedIn",

        subtitle: "Leadership & growth",

        description: "Professional updates · thought leadership · network",

        path: "https://www.linkedin.com/in/pooleymaria/",

        gradient: "from-zinc-700 via-zinc-800 to-black",
        border: "border-zinc-400",
      },
    ],
  },

  vi: {
    small: "Kết Nối Cùng Maria",

    title1: "Khám Phá",
    title2: "Thế Giới Của Tôi",

    description:
      "Theo dõi Maria Advisory trên các nền tảng mạng xã hội để cập nhật chiến lược kinh doanh, phát triển bản thân và các hoạt động cộng đồng mới nhất.",

    explore: "Khám phá nền tảng",
    visit: "Truy cập",

    cards: [
      {
        icon: Instagram,

        title: "Instagram",

        subtitle: "Hành trình phía sau",

        description:
          "Theo dõi hành trình kinh doanh, tư duy, cuộc sống và nguồn cảm hứng mỗi ngày.",

        path: "https://www.instagram.com/mariaadvisory/",

        gradient: "from-pink-500 via-fuchsia-500 to-orange-400",
        border: "border-pink-300",
      },

      {
        icon: Facebook,

        title: "Maria Advisory",

        subtitle: "Chiến lược kinh doanh",

        description:
          "Chia sẻ chiến lược phát triển doanh nghiệp, lãnh đạo và kinh nghiệm thực tế.",

        path: "https://www.facebook.com/mariaadvisory/",

        gradient: "from-blue-500 via-blue-600 to-indigo-700",
        border: "border-blue-300",
      },

      {
        icon: Facebook,

        title: "Maria Pooley",

        subtitle: "Hành trình cá nhân",

        description:
          "Theo dõi hành trình cá nhân, hoạt động cộng đồng và sự nghiệp chuyên môn.",

        path: "https://www.facebook.com/maria.pooley286/",

        gradient: "from-sky-500 via-cyan-600 to-blue-800",
        border: "border-cyan-300",
      },

      {
        icon: Linkedin,

        title: "LinkedIn",

        subtitle: "Lãnh đạo & phát triển",

        description:
          "Kết nối chuyên nghiệp và khám phá các chủ đề về lãnh đạo doanh nghiệp.",

        path: "https://www.linkedin.com/in/pooleymaria/",

        gradient: "from-zinc-700 via-zinc-800 to-black",
        border: "border-zinc-300",
      },
    ],
  },
};
